export var FillType;
(function (FillType) {
    FillType[FillType["Solid"] = 0] = "Solid";
    FillType[FillType["LinearGradient"] = 16] = "LinearGradient";
    FillType[FillType["RadialGradient"] = 18] = "RadialGradient";
    FillType[FillType["FocalRadialGradient"] = 19] = "FocalRadialGradient";
    FillType[FillType["RepeatingBitmap"] = 64] = "RepeatingBitmap";
    FillType[FillType["ClippedBitmap"] = 65] = "ClippedBitmap";
    FillType[FillType["NonsmoothedRepeatingBitmap"] = 66] = "NonsmoothedRepeatingBitmap";
    FillType[FillType["NonsmoothedClippedBitmap"] = 67] = "NonsmoothedClippedBitmap";
})(FillType || (FillType = {}));
